export default function Label(props) {
    return (
     <label className={`block text-sm font-medium text-gray-700 ${props.className}`}>
        {props.text}
      </label>
    );
}
